import styled from 'styled-components'

export const EditorPageMainDiv = styled.div`
  margin-top: 50px;
  @media screen and (max-width: 600px) {
    margin-top: 0;
    /* position: fixed; */
    width: 100%;
  }
`

export const IncentiveWrapper = styled.div`
  position: fixed;
  width: 100%;
  top: 88px;

  @media screen and (max-width: 600px) {
    position: static;
  }
`
